module.exports = __webpack_public_path__ + "img/pc-title.1e4f29fd.webp";